export const Status = {
  InStock: "in stock",
  OutOfStock: "out of stock",
  Preorder: "preorder",
};
